'use strict';

angular.module('pmtPlacesApp.directives').directive('pmtName', [
	function () {

		return {
			restrict: 'A',
			replace: true,
			scope: {
				pmtName: '@',
				diffObject: '=',
				disableHeader: '@'
			},
			link: function (scope, element, attrs) {
				scope.name = 'test';
				scope.showHeader = true;
				attrs.$observe('pmtName', function (newVal) {
					scope.name = newVal;
				});

				attrs.$observe('disableHeader', function (newVal) {
					scope.showHeader = !scope.$eval(newVal);
				});
			},
			templateUrl: 'shared/dataPrinters/pmtNameView.html'
		};
	}
]);
